<template>
  <div class="view-container screen--center">
    <div class="width-100">
      <v-row no-gutters>
        <v-col cols="12" class="mb-10 mt-10 text-center">
          <img src="@/assets/images/signup.png" alt="signup" />
          <br />
          <p class="font--m-3">
            셀러님의 정보 등록 <br />
            요청을 완료했습니다.
          </p>
        </v-col>
      </v-row>

      <v-row no-gutters>
        <v-col cols="12">
          <BasicButton @click="confirm" id="btn__x83mOmXjc0eOcFj8dXQVeQ==">확인</BasicButton>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters('auth', ['isApproved']),
  },
  methods: {
    ...mapActions('auth', ['getMe']),
    async confirm() {
      await this.getMe()
      // if (!this.isApproved) {
      //   await this.$swal.basic.alert({
      //     html: `정보 등록 요청이 완료되었습니다.<br />
      //   사업자 정보 확인 후 <br />
      //   알림톡을 통해 결과를 알려드려요`,
      //   })
      //   return
      // }
      await this.$router.push('/')
    },
  },
}
</script>
